import React from 'react';
import { Box, Grid, Tab, Tabs } from '@mui/material';
import AgentListPanel from './AgentListPanel';
import AgentDetailPanel from './AgentDetailPanel';
import AgentEditorDialog from './AgentEditorDialog';
import AgentA2AEndpointListPanel from './AgentA2AEndpointListPanel';
import AgentA2AEndpointEditorDialog from './AgentA2AEndpointEditorDialog';
import { useAgentRegistry } from '../../../../hooks/useAgentRegistry';
import { useAgentA2AEndpointRegistry } from '../../../../hooks/useAgentA2AEndpointRegistry';

type SubView = 'agents' | 'endpoints';

const AgentsView: React.FC = () => {
  const [subView, setSubView] = React.useState<SubView>('agents');

  const registry = useAgentRegistry();
  const endpointRegistry = useAgentA2AEndpointRegistry();

  return (
    <Box>
      <Tabs
        value={subView}
        onChange={(_e, v) => setSubView(v)}
        sx={{ mb: 2 }}
      >
        <Tab value="agents" label="Agents" />
        <Tab value="endpoints" label="A2A Endpoints" />
      </Tabs>

      <Box role="tabpanel" hidden={subView !== 'agents'}>
        {subView === 'agents' ? (
          <Grid container spacing={2}>
            <Grid item xs={12} xl={4}>
              <AgentListPanel
                agents={registry.agents}
                loading={registry.agentsLoading}
                selectedAgentId={registry.selectedAgentId}
                onSelect={registry.selectAgent}
                onAdd={registry.openCreate}
                onEdit={registry.openEdit}
                onDelete={registry.removeAgent}
                onRefresh={registry.refreshAll}
              />
            </Grid>

            <Grid item xs={12} xl={8}>
              <AgentDetailPanel
                agent={registry.agent}
                promptVersions={registry.promptVersions}
                capabilityScopes={registry.capabilityScopes}
                contextProviders={registry.contextProviders}
                routingRules={registry.routingRules}
                endpointScopes={registry.endpointScopes}
                a2aConfig={registry.a2aConfig}
                audits={registry.audits}
                onRefresh={registry.refreshAll}
                onEdit={registry.openEdit}
              />
            </Grid>
          </Grid>
        ) : null}
      </Box>

      <Box role="tabpanel" hidden={subView !== 'endpoints'}>
        {subView === 'endpoints' ? (
          <AgentA2AEndpointListPanel
            endpoints={endpointRegistry.endpoints}
            loading={endpointRegistry.endpointsLoading}
            onAdd={endpointRegistry.openCreate}
            onEdit={endpointRegistry.openEdit}
            onDelete={endpointRegistry.removeEndpoint}
            onRefresh={endpointRegistry.refreshAll}
          />
        ) : null}
      </Box>

      <AgentEditorDialog
        open={registry.editorOpen}
        initialValue={registry.editorInitialValue}
        submitting={registry.saving}
        agents={registry.agents}
        endpoints={registry.endpoints}
        entityTypes={registry.entityTypes}
        onClose={registry.closeEditor}
        onSubmit={registry.saveAgent}
      />

      <AgentA2AEndpointEditorDialog
        open={endpointRegistry.editorOpen}
        initialValue={endpointRegistry.editorInitialValue}
        submitting={endpointRegistry.saving}
        onClose={endpointRegistry.closeEditor}
        onSubmit={endpointRegistry.saveEndpoint}
      />
    </Box>
  );
};

export default AgentsView;
